import React, { useMemo } from 'react';
import backgroundImg from '../assets/images/new_main/gauge.png';
import gaugeBorderImg from '../assets/images/new_main/gauge_border.png'; // 테두리만 있는 이미지 필요
import sparkleImg from '../assets/images/new_main/sparkle.png';

const BananaGauge = ({ rate = 0 }) => {
  const clampedRate = Math.max(0, Math.min(100, rate)); //

  // 게이지 양에 따라 %값 표시 위치 변경
  /* const rateLavelPosition = useMemo(() => {
    const min = -4;
    const max = 76;

    const reversedRate = 1 - clampedRate / 100;
    return min + (max - min) * reversedRate;
  }, [clampedRate]); */

  return (
    // 게이지 에그 박스
    <div style={{ position: 'relative', display: 'flex', justifyItems: 'center' }}>
      {/* 1) 시간 표시 */}
      <div
        style={{
          position: 'absolute',
          top: -20,
          left: 20,
          color: '#fff',
          fontSize: 12,
          fontWeight: 'bold',
          whiteSpace: 'nowrap',
          zIndex: 1,
          display: 'flex',
          alignItems: 'center',
          textShadow: `
            -1px -1px 0 #663440,  
            1px -1px 0 #663440,  
            -1px 1px 0 #663440,  
            1px 1px 0 #663440
          `,
        }}
      >
        {clampedRate}%
        {/* <div
          style={{
            width: 20,
            height: 1,
            backgroundColor: '#663440',
            marginLeft: 4,
          }}
        /> */}
      </div>

      {/* 2) 게이지 */}
      <div
        style={{
          paddingLeft: 12,
        }}
      >
        {/* 2-1) 게이지 실제 크기 */}
        <div
          style={{
            position: 'relative',
            width: 24.79,
            height: 86.38,
          }}
        >
          {/* 배경 이미지 - 투명한 내부를 가진 이미지 */}
          <img
            src={backgroundImg}
            alt="gauge background"
            style={{
              width: '100%',
              height: '100%',
              position: 'absolute',
              top: 0,
              left: 0,
              zIndex: 1,
            }}
          />

          {/* 게이지 채움 - 배경 이미지와 같은 마스크 사용 */}
          <div
            style={{
              position: 'absolute',
              left: 0,
              top: 0,
              width: '100%',
              height: '100%',
              WebkitMaskImage: `url(${backgroundImg})`,
              maskImage: `url(${backgroundImg})`,
              WebkitMaskSize: '100% 100%',
              maskSize: '100% 100%',
              zIndex: 2,
            }}
          >
            <div
              style={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                width: '100%',
                height: `${clampedRate}%`,
                background: `linear-gradient(to top,
                rgba(19, 164, 24, 1),
                rgba(67, 206, 72, 1) 50%, 
                rgba(167, 231, 39, 1) 
              )`,
                transition: 'height 0.3s ease',
              }}
            />
          </div>

          {/* 테두리 이미지 - 항상 최상위에 표시 */}
          <img
            src={gaugeBorderImg || backgroundImg}
            alt="gauge border"
            style={{
              width: '100%',
              height: '100%',
              position: 'absolute',
              top: 0,
              left: 0,
              zIndex: 3,
              pointerEvents: 'none',
            }}
          />

          {/* 반짝임 효과 */}
          <img
            src={sparkleImg}
            alt="sparkle"
            style={{
              position: 'absolute',
              top: -10,
              right: -25,
              width: 23,
              height: 30.83,
              zIndex: 4,
            }}
          />
        </div>
      </div>

      {/* 3) 에그 */}
      {/* <div style={{ position: 'relative' }}>
        <div style={{ position: 'absolute', bottom: -10, left: 4 }}>
          <EggImagSmall eggId={'E_0_4'} />
        </div>
      </div> */}
    </div>
  );
};

export default BananaGauge;
